import React, { useCallback, useEffect, useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import BdsInput from '../../../../../shared/components/v3/BdsInput/BdsInput';
import BdsCardContainer from '../../../../../shared/components/v3/Cards/BdsCardContainer/BdsCardContainer';
import { IChallengeGoalProps } from '../../../../../shared/interfaces/challenges';
import { TRANSLATION_CHALLENGES } from '../../../../../shared/translations/challenges';
import { parseFormattedNumber } from '../../../../../shared/utils/utils';

import './ChallengeGoal.scss';

const ChallengeGoal = ({ challengeInfo, challenge, validateForm, updateChallenge }: IChallengeGoalProps) => {
  const [challengeGoal, setChallengeGoal] = useState<number>(challenge.goal);
  const initValue = challengeGoal ? challengeGoal.toString() : '';
  const minValueGoal = parseFormattedNumber(challengeInfo.minValueGoal);
  const { t } = useTranslation();

  const handleChange = useCallback(
    (value: string) => {
      const goal = Number(value);
      setChallengeGoal(goal);
      updateChallenge({ goal: goal });
      if (goal && goal >= minValueGoal) {
        validateForm(true);
      } else {
        validateForm(false);
      }
    },
    [minValueGoal, validateForm]
  );

  const validateInput = (value: string | null) => {
    if (!value) return null;
    const num = Number(value);
    if (Number.isNaN(num)) {
      return t(TRANSLATION_CHALLENGES.createChallenge.inputGoalError);
    }
    if (num < minValueGoal) {
      return t(TRANSLATION_CHALLENGES.createChallenge.inputGoalMinError, {
        min: minValueGoal,
        challenge_type: challengeInfo.goalMeasured
      });
    }
    return null;
  };

  useEffect(() => {
    challenge.goal && handleChange(challenge.goal.toString());
  }, [challenge.goal, handleChange]);

  return (
    <div className="challenge-goal-container">
      <div className="row">
        <div className="goal-container">
          <div className="title">{challengeInfo.createChallengeLabel}</div>
          <BdsInput
            hintText={challengeInfo.createChallengeLabel}
            helperText={challengeInfo.recommendation}
            initValue={initValue}
            onChanged={handleChange}
            validator={validateInput}
          />
        </div>
        <BdsCardContainer className="reward-card" paddingSize="padding-m" borderRadiusSize="radius-l">
          <div className="title">{t(TRANSLATION_CHALLENGES.createChallenge.rewardInfo.title)}</div>
          <div className="description">
            <Trans
              i18nKey={TRANSLATION_CHALLENGES.createChallenge.rewardInfo.description}
              components={{
                b: <b></b>,
                br: <br />
              }}
            />
          </div>
        </BdsCardContainer>
      </div>
    </div>
  );
};

export default ChallengeGoal;
